/**
 * 外币支付状态 0默认状态 1支付成功 -1支付失败
 * @type {number}
 */
const foreignState = 0;
export default {
    foreignState
}